// extracted by mini-css-extract-plugin
module.exports = {"card":"Funding_card__1WDNz","top":"Funding_top__16T74","left":"Funding_left__1vka1","right":"Funding_right__1EWv5","bottom":"Funding_bottom__2IzJn"};